var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_5018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.879028 19.4092C0.199575 19.4092 -0.219722 20.1454 0.120825 20.7333C0.884009 22.0511 2.30965 22.9395 3.93897 22.9395H26.061C27.6904 22.9395 29.116 22.0511 29.8792 20.7333C30.2197 20.1454 29.8004 19.4092 29.121 19.4092H0.879028Z",
    fill: "#E8CF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4697 17.6514V7.93945C26.4697 7.45406 26.0762 7.06055 25.5908 7.06055H19.4092V13.1763C19.4092 14.6342 18.2231 15.8203 16.7651 15.8203C15.3072 15.8203 14.1211 14.6342 14.1211 13.1763V12.3047H13.2349C11.7769 12.3047 10.5908 11.1186 10.5908 9.66064V7.06055H4.40918C3.92379 7.06055 3.53027 7.45406 3.53027 7.93945V17.6514H26.4697Z",
    fill: "#E8CF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3486 9.66064C12.3486 10.1493 12.7462 10.5469 13.2349 10.5469H15C15.4854 10.5469 15.8789 10.9404 15.8789 11.4258V13.1763C15.8789 13.6649 16.2765 14.0625 16.7651 14.0625C17.2538 14.0625 17.6514 13.6649 17.6514 13.1763V7.06055H12.3486V9.66064Z",
    fill: "#E8CF7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_5018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFat);
export default __webpack_public_path__ + "static/media/fat.08c24fdec8f27c5c956963fdf02fbd08.svg";
export { ForwardRef as ReactComponent };